<div class="course-details-dialog-container">
  <app-course-details 
    [id]="data?.id" 
    [dialogMode]="true">
  </app-course-details>

  <button mat-raised-button class="button button--icon button--icon-rounded button--white dialog-close-button" mat-dialog-close="false">
    <lib-icon icon="x"></lib-icon>
  </button>
</div>